import { post } from '@/util/request'

export default {
    /**
     * 查询数据
     * @param query
     * @returns {*}
     */
  getData:query => post(`/monitor/search`,query),

    /**
     * 加入预警
     * @param query
     * @returns {*}
     */
    addWarning:query => post(`/monitor/addWarning`,query),
	/**
	 * 获取标签 id:1与 地域标签 id:2
	 * @param query
	 * @returns {*}
	 */
	getTags:query => post(`/system/tag`,query),
}
